import { Button } from '@mui/material'
import React, { useCallback } from 'react'
import { makeStyles } from 'tss-react/mui'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useNavigate, useParams } from 'react-router-dom'
import useModals from 'src/Hooks/useModals'
import { BannerCloseTypes, BannerKey } from 'src/Libs/banners/types'
import { Banner } from 'src/Components/banner'
import { extensionColors } from '../../colors'
import { useNewRelic } from '@e3dc-react/shell/Libs/observability-tool'
import { useUserSettings } from 'src/Hooks'

const useStyles = makeStyles()(theme => ({
  containerStyle: {
    background: extensionColors.eon.secondary,
  },
  infoButton: {
    minWidth: 'max-content',
    color: theme.palette.common.white,
    borderColor: theme.palette.common.white,
    '&:hover': {
      borderColor: theme.palette.common.white,
    },
  },
  text: {
    color: theme.palette.common.white,
  },
  closeActionStyle: {
    color: theme.palette.common.white,
  },
}))

/**
 * This component displays a banner informing about the Eon extension.
 */
const EonBanner: React.FC = () => {
  const { classes } = useStyles()
  const { t } = useCustomTranslation()
  const { installationId, storageId } = useParams<{ installationId: string; storageId: string }>()
  const { openEonModal } = useModals()
  const navigate = useNavigate()
  const { userSettings } = useUserSettings()
  const { pageActions } = useNewRelic()

  const redirectToInstallationExtensions = useCallback(() => {
    pageActions.componentClicked({
      componentName: 'EonBanner',
      userId: userSettings.userid?.toString(),
    })
    navigate(`/installation-extensions/${installationId}/${storageId}`)
    openEonModal()
  }, [pageActions, userSettings.userid, navigate, installationId, storageId, openEonModal])

  return (
    <Banner
      bannerKey={BannerKey.EonOfferBanner}
      button={
        <Button className={classes.infoButton} onClick={redirectToInstallationExtensions}>
          {t('installation-extension.banner.get-bonus-now')}
        </Button>
      }
      i18nKey="installation-extension.banner.eon.new-offer"
      textStyle={classes.text}
      containerStyle={classes.containerStyle}
      closeType={BannerCloseTypes.permanentOrTemporary}
      closeActionStyle={classes.closeActionStyle}
    />
  )
}

export default EonBanner
